import { defineStore } from 'pinia'
import { reactive, watchEffect } from 'vue'
import { useRoute } from 'vue-router'
import { useTranslate } from '@/shared/lib'
import type { Meta } from './types'

/**
 * Функция установки метаданных для страницы
 *
 * @param meta
 */

export const useMeta = defineStore('meta', () => {
  const route = useRoute()
  const { trs } = useTranslate()

  const postfix = 'Система управления - Unilight'

  const data = reactive<Meta>({
    title: postfix,
    breadcrumbs: [],
  })

  /**
   * Метод установки мета данных и
   * хлебных крошек
   *
   * @param value
   */
  const set = (value: Meta) => {
    data.title = value.title
    data.icon = value.icon || 'browse'
    data.breadcrumbs = route.name === 'index' ? [] : [{ title: 'itf.home', to: '/' }]

    value.breadcrumbs?.forEach((breadcrumb) => {
      data.breadcrumbs?.push(breadcrumb)
    })

    data.breadcrumbs.push(value.title)

    return this
  }

  watchEffect(() => {
    document.title = data.title ? `${trs(data.title)} | ${postfix}` : postfix
  })

  return {
    data,

    set,
  }
})

export * from './types'
